import { statusPresentation } from './rosterUploadFormat';

interface RosterUploadStatusBadgeProps {
  status: string | null;
}

/** The upload's status as a word on a tinted pill. The word carries the meaning; colour only echoes it. */
export const RosterUploadStatusBadge = ({ status }: RosterUploadStatusBadgeProps) => {
  const { label, tone } = statusPresentation(status);
  return <span className={`roster-uploads__status roster-uploads__status--${tone}`}>{label}</span>;
};
